import $http from '@/plugins/axios'

const RESOURCE_NAME = '/admin/category'
const CATEGORIES = 'categories'
const BISAC_CODES = 'bisacCodes'
const BSM_CATEGORIES = 'bsmCategories'

export default {
  async getCategorySearchSuggestions (keyword) {
    let res = await $http().get(`${RESOURCE_NAME}/${CATEGORIES}`, {
      params: {
        keyword: keyword,
        skipCount: 0,
        maxResultCount: 8
      }
    })
    res = res.items.map((item) => {
      return item.categoryName
    })
    return res
  },

  async getBisacCodeSearchSuggestions (keyword, isMapped) {
    let res = await $http().get(`${RESOURCE_NAME}/${BISAC_CODES}`, {
      params: {
        keyword: keyword,
        skipCount: 0,
        maxResultCount: 8,
        isMapped: isMapped
      }
    })
    res = res.items.map((item) => `${item.subjectCode} ${item.subject}`)
    return res
  },

  async getBsmCategorySearchSuggestions (keyword, isUsed) {
    let res = await $http().get(`${RESOURCE_NAME}/${BSM_CATEGORIES}`, {
      params: {
        keyword: keyword,
        skipCount: 0,
        maxResultCount: 8,
        isUsed: isUsed
      }
    })
    res = res.items.map((item) => item.categoryCode)
    return res
  },

  getDataPaged (endpoint, keyword, skipCount, itemsPerPage, isMapped, isUsed) {
    return $http().get(`${RESOURCE_NAME}/${endpoint}`, {
      params: {
        keyword: keyword,
        skipCount: skipCount,
        maxResultCount: itemsPerPage,
        isMapped: isMapped,
        isUsed: isUsed
      }
    })
  },

  getCategories () {
    return this.getDataPaged(`${CATEGORIES}`, '', 0, 0, null, null)
  },

  async getRootCategories () {
    return $http().get(`${RESOURCE_NAME}/${CATEGORIES}/tree`)
  },

  getCategory (id) {
    return $http().get(`${RESOURCE_NAME}/${CATEGORIES}/${id}`, { handleError: false })
  },

  createCategory (category) {
    return $http().post(`${RESOURCE_NAME}/${CATEGORIES}`, category)
  },

  updateCategory (category) {
    return $http().patch(`${RESOURCE_NAME}/${CATEGORIES}/${category.id}`, category)
  },

  deleteCategory (id) {
    return $http().delete(`${RESOURCE_NAME}/${CATEGORIES}/${id}`)
  },

  getProductsForCategory (id) {
    return $http().get(`${RESOURCE_NAME}/${CATEGORIES}/${id}`)
  },

  getBisacCode (id) {
    return $http().get(`${RESOURCE_NAME}/${BISAC_CODES}/${id}`)
  },

  updateBisacCode (bisacCode) {
    return $http().patch(`${RESOURCE_NAME}/${BISAC_CODES}/${bisacCode.id}`, bisacCode)
  },

  getBsmCategory (id) {
    return $http().get(`${RESOURCE_NAME}/${BSM_CATEGORIES}/${id}`)
  },

  updateBsmCategory (category) {
    return $http().patch(`${RESOURCE_NAME}/${BSM_CATEGORIES}/${category.id}`, category)
  }
}
